export enum VisitorMessageType {
  Email = 'email',
  Browse = 'browse',
  SMS = 'sms',
}

export interface Cycle {
  id: string;
  messageType: VisitorMessageType;
  delay: number;
  subjectLineId: string;
  templateId: string;
  name?: string;
}
